import { useEffect, useState } from 'react';
import {
    Grid,
    TextField,
    Box,
    InputLabel,
    FormControl,
    Select,
    MenuItem
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { ActionContext } from 'src/contexts/ActionContext';
import { EaSkillData } from 'src/models/skill/skill.model';
import { CURRENT_USER } from 'src/constants';
import { useParams } from 'react-router-dom';
import { User } from 'src/models/user/user.model';

function CompetenceBMItem(props) {
    const {
        actionToggle
    } = useContext(ActionContext);
    const errorBorderStyle = {
        "& .MuiInputBase-root.Mui-disabled": {
            "& fieldset": {
                borderColor: "#FF1943"
            }
        }
    }
    const { t } = useTranslation();
    const params = useParams();
    const [colorManager, setColorManager] = useState<string>("");
    const [colorConsultant, setColorConsultant] = useState<string>("");
    const [skill, setSkill] = useState<EaSkillData>(props.skill);
    const [isUserHimSelf, setIsUserHimSelf] = useState<boolean>(false);
    const userData: User = JSON.parse(localStorage.getItem(CURRENT_USER));
    const isVisu = !actionToggle;
    const [goalColor, setGoalColor] = useState<string>("");
    const [goalTextColor, setGoalTextColor] = useState<string>("");
    const idBusinessManager = props.idBusinessManager;

    const getGoalValue = (skillData) => {
        if (idBusinessManager == 1) {
            return skillData.bmgoal
        } else if (idBusinessManager == 2) {
            return skillData.sbmgoal
        } else if (idBusinessManager == 3) {
            return skillData.bumgoal
        } else if (idBusinessManager == 4) {
            return skillData.sbumgoal
        } else if (idBusinessManager == 5) {
            return skillData.budgoal
        } else if (idBusinessManager == 6) {
            return skillData.sbudgoal
        } else { return 0 }
    }
    useEffect(() => {
        if (parseInt(params.id) == userData.id) {
            setIsUserHimSelf(true)
            setColorManager("#e6e6e6")
            setColorConsultant("")
        } else {
            setIsUserHimSelf(false)
            setColorManager("")
            setColorConsultant("#e6e6e6")
        }
    }, []);
    const getGoalColor = (evaluationConsultant, evaluationManager, goal) => {
        if (((evaluationConsultant == null || evaluationConsultant == -1) && (evaluationManager == null || evaluationManager == -1))) {
            setGoalColor("")
            setGoalTextColor("")
        } else {
            let evalConsultant = (evaluationConsultant == null || evaluationConsultant == -1) ? goal : evaluationConsultant
            let evalManager = (evaluationManager == null || evaluationManager == -1) ? goal : evaluationManager
            let moyen = (evalConsultant + evalManager) / 2
            if (moyen >= goal) {
                setGoalColor("rgb(44, 154, 66)")
            } else {
                setGoalColor("orange")
            }
            setGoalTextColor("white")
        }
    }
    useEffect(() => {
        getGoalColor(skill.evaluationConsultant, skill.evaluationManager, skill.goal)
    }, [skill.evaluationConsultant, skill.evaluationManager, skill.goal]);

    useEffect(() => {
        if (props.skill != undefined) {
            setSkill(props.skill);
            let goalValue = getGoalValue(props.skill);
            getGoalColor(props.skill.evaluationConsultant, props.skill.evaluationManager, goalValue)
        }
    }, [props.skill]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSkill({
            ...skill,
            [name]: value == -1 ? null : value
        });
    }
    const onBlur = () => {
        props.onBlur(skill)
    }

    useEffect(() => {
        let goalValue = getGoalValue(skill)
        setSkill({
            ...skill,
            goal: goalValue
        });
    }, [idBusinessManager]);

    return (
        <>
            <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1} >
                <Grid item xs={4}>
                    <Box
                        sx={{
                            minHeight: 41,
                            borderRadius: 1,
                            border: '2px solid #e6e6e6',
                            alignItems: 'center',
                            display: 'flex'
                        }}
                    >
                        <span style={{
                            fontWeight: 700, textAlign: 'left',
                            margin: '10px 10px 10px 10px'
                        }}>
                            {skill.skillName}
                        </span>
                    </Box>
                </Grid>
                <Grid item xs={1} >
                    <Box
                        sx={{
                            height: 41,
                            borderRadius: 1,
                            border: '2px solid #e6e6e6',
                            alignItems: 'center',
                            display: 'flex',
                            background: goalColor,
                            color: goalTextColor
                        }}
                    >
                        <span style={{
                            fontWeight: 700,
                            marginLeft: '40%'

                        }}>
                            {skill.goal}
                        </span>
                    </Box>
                </Grid>
                <Grid item xs={2} >
                    <Grid item xs={12} >
                        <FormControl fullWidth disabled={isUserHimSelf ? isVisu : true}
                            error={!isVisu && (skill.evaluationConsultant == null || skill.evaluationConsultant == -1) && isUserHimSelf}
                            sx={(!isVisu && (skill.evaluationConsultant == null || skill.evaluationConsultant == -1) && isUserHimSelf) ? errorBorderStyle : {}}>
                            <InputLabel
                                style={{
                                    backgroundColor: 'white',
                                    marginTop: 0,
                                    borderRadius: 7
                                }}
                            >
                                <Trans>eepBm.evaluation.noteConsultantLabel</Trans>
                            </InputLabel>
                            <Select
                                label={t('eepBm.evaluation.noteConsultantLabel')}
                                displayEmpty
                                style={{
                                    textAlign: 'left',
                                    backgroundColor: colorConsultant
                                }}
                                value={skill.evaluationConsultant ?? -1}
                                name="evaluationConsultant"
                                onChange={handleChange}
                                onBlur={onBlur}
                            >
                                <MenuItem key={-1} value={-1}>{/*<Trans>eepBm.evaluation.noteDefault</Trans>*/}</MenuItem>
                                <MenuItem key={0} value={0}><Trans>eepBm.evaluation.note0</Trans></MenuItem>
                                <MenuItem key={1} value={1}><Trans>eepBm.evaluation.note1</Trans></MenuItem>
                                <MenuItem key={2} value={2}><Trans>eepBm.evaluation.note2</Trans></MenuItem>
                                <MenuItem key={3} value={3}><Trans>eepBm.evaluation.note3</Trans></MenuItem>
                                <MenuItem key={4} value={4}><Trans>eepBm.evaluation.note4</Trans></MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} >
                        <FormControl fullWidth disabled={!isUserHimSelf ? isVisu : true}
                            error={!isVisu && (skill.evaluationManager == null || skill.evaluationManager == -1) && !isUserHimSelf}
                            sx={(!isVisu && (skill.evaluationManager == null || skill.evaluationManager == -1) && !isUserHimSelf) ? errorBorderStyle : {}}
                        >
                            <InputLabel
                                style={{
                                    backgroundColor: 'white',
                                    marginTop: 9,
                                    borderRadius: 7
                                }}
                            >
                                <Trans>eepBm.evaluation.noteManagerLabel</Trans>
                            </InputLabel>
                            <Select
                                label={t('eepBm.evaluation.noteManagerLabel')}
                                displayEmpty
                                style={{
                                    textAlign: 'left',
                                    backgroundColor: colorManager,
                                    marginTop: 9
                                }}
                                value={skill.evaluationManager ?? -1}
                                name="evaluationManager"
                                onChange={handleChange}
                                onBlur={onBlur}
                            >
                                <MenuItem key={-1} value={-1}>{/*<Trans>eepBm.evaluation.noteDefault</Trans>*/}</MenuItem>
                                <MenuItem key={0} value={0}><Trans>eepBm.evaluation.note0</Trans></MenuItem>
                                <MenuItem key={1} value={1}><Trans>eepBm.evaluation.note1</Trans></MenuItem>
                                <MenuItem key={2} value={2}><Trans>eepBm.evaluation.note2</Trans></MenuItem>
                                <MenuItem key={3} value={3}><Trans>eepBm.evaluation.note3</Trans></MenuItem>
                                <MenuItem key={4} value={4}><Trans>eepBm.evaluation.note4</Trans></MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item xs={5} >
                    <Grid item xs={12} >
                        <TextField
                            fullWidth
                            style={{
                                backgroundColor: colorConsultant,
                            }}
                            multiline
                            name="commentConsultant"
                            value={skill.commentConsultant}
                            onChange={handleChange}
                            onBlur={onBlur}
                            disabled={isUserHimSelf ? isVisu : true}
                            label={t('eepBm.evaluation.commentConsultantLabel')}
                            InputLabelProps={{
                                style: {
                                    backgroundColor: skill.commentConsultant != '' ? 'white' : colorConsultant,
                                    borderRadius: 7
                                },
                            }}
                            inputProps={{
                                maxLength: 4094
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            multiline
                            style={{
                                backgroundColor: colorManager,
                                marginTop: 9
                            }}
                            name="commentManager"
                            value={skill.commentManager}
                            onChange={handleChange}
                            onBlur={onBlur}
                            disabled={!isUserHimSelf ? isVisu : true}
                            label={t('eepBm.evaluation.commentManagerLabel')}
                            InputLabelProps={{
                                style: {
                                    backgroundColor: skill.commentManager != '' ? 'white' : colorManager,
                                    borderRadius: 7
                                },
                            }}
                            inputProps={{
                                maxLength: 4094
                            }}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default CompetenceBMItem;